<template>
    <div>
        <template>
            <div class="flex items-center leading-none py-1">
                <div class="flex w-full flex-nowrap justify-between">
                    <h4 class="text-lg mr-4">{{ displayName }}</h4>
                </div>
            </div>
            <div class="ml-3 pl-6 mt-2 right-bordered">
                <div class="flex">
                    <div class="flex-col w-1/2">
                        <h4>Patient</h4>
                        <div class="ml-4 primaryColor">
                            {{ request.patientFirstName }} {{ request.patientLastName }}
                        </div>
                    </div>
                    <div class="flex-col w-1/2">
                        <h4>Practice</h4>
                        <div class="ml-4 primaryColor">{{ request.practiceName }}</div>
                    </div>
                </div>
                <vs-divider />
                <div class="flex-col">
                    <div class="flex">
                        <h4>Request Details</h4>
                        <div class="ml-2">{{ claimed }}</div>
                    </div>
                    <div class="flex">
                        <div class="flex-col w-1/2">
                            <div class="flex ml-4 w-1/2 flex-nowrap justify-between">
                                <div class="title">Status</div>
                                <div class="primaryColor">{{ status.name }}</div>
                            </div>
                            <div class="flex ml-4 w-1/2 flex-nowrap justify-between">
                                <span class="title">Urgency</span>
                                <span class="primaryColor"> {{ urgency.name }}</span>
                            </div>
                        </div>
                        <div class="flex-col w-1/2">
                            <div class="flex w-1/2 flex-nowrap justify-between">
                                <span class="title">Cost Centre</span>
                                <span class="primaryColor">{{ request.costCentreName }}</span>
                            </div>
                            <div class="flex w-1/2 flex-nowrap justify-between">
                                <span class="title"># of Service Tasks</span>
                                <span>{{ request.serviceTaskCount }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'request-suggest-item',
    props: {
        request: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            getUrgencyById: 'maarima/getUrgencyById',
            getRequestStatusById: 'maarima/getRequestStatusById'
        }),
        address() {
            return this.request.address
        },
        displayName() {
            return `#${this.request.id}`
        },
        status() {
            return this.getRequestStatusById(this.request.statusId)
        },
        urgency() {
            return this.getUrgencyById(this.request.urgencyId)
        },
        claimed() {
            if (this.request.isClaimed) {
                return '(Claimed)'
            }
            return '(Not claimed)'
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/vuexy/_variables.scss';

.left-bordered {
    border-left: 1px solid rgba(var(--vs-dark), 1);
}

.primaryColor {
    color: rgba(var(--vs-primary), 1);
}
</style>
